export { default } from './WalletInfo';

